import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';

export default class ClickAwayPopper extends Component {
  static propTypes = {
    onClose: PropTypes.func
  }

  render() {
    const { onClose, children, ...rest } = this.props;

    return (
      <Popper {...rest}>
        <ClickAwayListener onClickAway={onClose}>
          {children}
        </ClickAwayListener>
      </Popper>
    );
  }
}
